import { LogOut, UserCog } from "lucide-react";
import { Link } from "react-router";
import { useAuth } from "../../auth/AuthProvider";
import { ThemeToggle } from "./ThemeToggle";

type UserFooterProps = {
  collapsed?: boolean;
};

export function UserFooter({ collapsed }: UserFooterProps) {
  const { user, logout } = useAuth();

  const initials = user?.email
    ? user.email.slice(0, 1).toUpperCase()
    : "·";
  const role = user?.is_superadmin
    ? "Super-admin"
    : user?.roles?.[0] || "Tenant member";

  return (
    <div
      className={`mx-3 my-3 flex items-center hair-t pt-3 ${
        collapsed ? "flex-col justify-center gap-2" : "gap-2.5"
      }`}
    >
      {collapsed && <ThemeToggle />}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-ink text-[12px] font-medium text-paper-hi">
        {initials}
      </div>
      {!collapsed && (
        <>
          <div className="min-w-0 flex-1">
            <div className="truncate text-[12.5px] font-medium">
              {user?.email || "Signed in"}
            </div>
            <div className="truncate text-[11px] text-ink-4">{role}</div>
          </div>
          <ThemeToggle />
          <Link
            to="/account"
            aria-label="Account settings"
            title="Account settings"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-ink-4 transition hover:bg-paper-2 hover:text-ink"
          >
            <UserCog size={15} />
          </Link>
          <button
            type="button"
            onClick={() => {
              void logout();
            }}
            aria-label="Sign out"
            title="Sign out"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-ink-4 transition hover:bg-paper-2 hover:text-ink"
          >
            <LogOut size={15} />
          </button>
        </>
      )}
    </div>
  );
}
